import React from 'react';
import { Download, Upload, File as FileIcon, DollarSign, CheckCircle, MessageSquare, Send } from 'lucide-react';

export default function SeguimientoTramiteSection({
  formSeg,
  loadingSeg,
  resultadoSeg,
  onSegChange,
  onSearch,
  onDownloadDoc,
  onSubirComprobante,
  uploadingComprobante,
  comentario,
  setComentario,
  onEnviarComentario,
  enviandoComentario,
  getBadgeClass
}) {
  return (
    <div className="animate-fade-in">
      <div className="glass-card" style={{ textAlign: 'left', background: 'var(--bg-surface)', marginBottom: '2rem' }}>
        <form onSubmit={onSearch}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
            <div className="form-group mb-0">
              <label>RUT Solicitante</label>
              <input
                type="text"
                name="rut_solicitante"
                value={formSeg.rut_solicitante}
                onChange={onSegChange}
                placeholder="Ej: 12345678-9"
                required
              />
            </div>
            <div className="form-group mb-0">
              <label>Número de Seguimiento</label>
              <input
                type="text"
                name="numero_seguimiento"
                value={formSeg.numero_seguimiento}
                onChange={onSegChange}
                placeholder="Ej: TRM-9A2X-55P"
                required
              />
            </div>
          </div>
          <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loadingSeg}>
            {loadingSeg ? <><span className="spinner" /> Consultando...</> : '🔍 Buscar Trámite'}
          </button>
        </form>
      </div>

      {resultadoSeg && (
        <div className="resultado-seguimiento-container">
          {/* ── SECCIÓN DE MENSAJES Y COMUNICACIÓN ── */}
          <div className="glass-card animate-fade-in" style={{ marginTop: '2rem', padding: '1.5rem', background: '#ffffff', border: '1px solid #e2e8f0' }}>
            <h3 style={{ fontSize: '1.1rem', color: 'var(--primary-dark)', marginBottom: '1.2rem', display: 'flex', alignItems: 'center', gap: 8 }}>
              <MessageSquare size={20} color="var(--primary)" /> Mensajes y Notificaciones
            </h3>

            {/* ── SECCIÓN DE COTIZACIÓN Y PAGO ── */}
            {resultadoSeg.cotizacion && (
              <div style={{
                marginBottom: '2rem',
                padding: '1.5rem',
                background: '#f8fafc',
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
                borderLeft: '4px solid var(--primary)'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
                  <h4 style={{ margin: 0, fontSize: '1rem', color: 'var(--primary-dark)', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <DollarSign size={18} /> Detalle de Cotización
                  </h4>
                  <div className={`badge ${getBadgeClass(resultadoSeg.estado?.nombre)}`} style={{ textTransform: 'uppercase', fontSize: '0.7rem' }}>
                    {resultadoSeg.estado?.nombre}
                  </div>
                </div>

                <div style={{ background: 'white', borderRadius: '8px', overflow: 'hidden', border: '1px solid #e2e8f0', marginBottom: '1rem' }}>
                  <table style={{ width: '100%', fontSize: '0.85rem', borderCollapse: 'collapse' }}>
                    <thead style={{ background: '#f1f5f9', color: '#475569' }}>
                      <tr>
                        <th style={{ textAlign: 'left', padding: '8px 12px' }}>Descripción</th>
                        <th style={{ textAlign: 'right', padding: '8px 12px' }}>Monto</th>
                      </tr>
                    </thead>
                    <tbody>
                      {resultadoSeg.cotizacion.items?.map((item, idx) => (
                        <tr key={idx} style={{ borderTop: '1px solid #f1f5f9' }}>
                          <td style={{ padding: '8px 12px' }}>{item.descripcion}</td>
                          <td style={{ padding: '8px 12px', textAlign: 'right' }}>${item.monto?.toLocaleString('es-CL')}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot style={{ background: '#f8fafc', fontWeight: 700 }}>
                      {resultadoSeg.cotizacion.descuento_monto > 0 && (
                        <tr>
                          <td style={{ padding: '10px 12px', color: 'var(--success)' }}>
                            Descuento Global {resultadoSeg.cotizacion.descuento_tipo === 'porcentaje' ? `(${resultadoSeg.cotizacion.descuento_monto}%)` : ''}
                          </td>
                          <td style={{ padding: '10px 12px', textAlign: 'right', color: 'var(--success)' }}>
                            {resultadoSeg.cotizacion.descuento_tipo === 'porcentaje' ? '-' : `-$${resultadoSeg.cotizacion.descuento_monto.toLocaleString('es-CL')}`}
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td style={{ padding: '10px 12px', borderTop: '1px solid #e2e8f0' }}>Total a Pagar</td>
                        <td style={{ padding: '10px 12px', textAlign: 'right', fontSize: '1rem', color: 'var(--primary)', borderTop: '1px solid #e2e8f0' }}>
                          ${resultadoSeg.cotizacion.total?.toLocaleString('es-CL')}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                {resultadoSeg.cotizacion.observaciones && (
                  <p style={{ fontSize: '0.8rem', color: '#64748b', fontStyle: 'italic', marginBottom: '1.2rem' }}>
                    Nota del funcionario: {resultadoSeg.cotizacion.observaciones}
                  </p>
                )}

                {/* Subida de Comprobante */}
                {['Pendiente Pago', 'Comprobante Pago Recibido'].includes(resultadoSeg.estado?.nombre) ? (
                  <div style={{ background: 'rgba(var(--primary-rgb), 0.05)', padding: '1rem', borderRadius: '8px', border: '1px dashed var(--primary)' }}>
                    <p style={{ margin: '0 0 0.8rem 0', fontSize: '0.85rem', fontWeight: 600, color: resultadoSeg.cotizacion?.estado === 'rechazada' ? '#991b1b' : 'inherit' }}>
                      {resultadoSeg.cotizacion?.estado === 'rechazada'
                        ? '❌ Tu comprobante anterior fue rechazado por caja. Por favor, sube uno nuevo.'
                        : resultadoSeg.estado?.nombre === 'Comprobante Pago Recibido'
                        ? '✅ Ya hemos recibido un comprobante, pero puedes subir uno nuevo si te equivocaste.'
                        : 'Para continuar, por favor adjunta tu comprobante de transferencia:'}
                    </p>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      <label className="btn btn-outline btn-sm" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, margin: 0 }}>
                        <Upload size={14} /> {uploadingComprobante ? 'Subiendo...' : 'Seleccionar Archivo'}
                        <input
                          type="file"
                          style={{ display: 'none' }}
                          accept=".pdf,.jpg,.jpeg,.png"
                          disabled={uploadingComprobante}
                          onChange={(e) => onSubirComprobante(e.target.files[0])}
                        />
                      </label>
                      <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>Formatos: PDF, JPG, PNG</span>
                    </div>
                  </div>
                ) : resultadoSeg.estado?.nombre === 'Pagado' ? (
                  <div style={{ background: '#ecfdf5', color: '#065f46', padding: '1rem', borderRadius: '8px', display: 'flex', alignItems: 'center', gap: 10 }}>
                    <CheckCircle size={20} />
                    <div>
                      <div style={{ fontWeight: 700, fontSize: '0.9rem' }}>Pago Confirmado</div>
                      <div style={{ fontSize: '0.8rem' }}>Tu pago ha sido validado exitosamente. Estamos procesando tu documentación final.</div>
                    </div>
                  </div>
                ) : null}
              </div>
            )}

            {resultadoSeg.estado?.nombre === 'Rehusado' && resultadoSeg.url_documento_rehusado && (
              <div style={{ background: '#fef2f2', padding: '1rem', borderRadius: '8px', border: '1px solid #fecaca', marginBottom: '1.5rem' }}>
                <p style={{ margin: '0 0 0.8rem 0', fontSize: '0.85rem', fontWeight: 600, color: '#991b1b' }}>
                  📄 Se adjunta la Resolución de Rehúso firmada por el Conservador.
                </p>
                <a
                  href={resultadoSeg.url_documento_rehusado}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline btn-sm"
                  style={{ borderColor: '#fca5a5', color: '#b91c1c', display: 'inline-flex', gap: '6px', alignItems: 'center', background: '#fff' }}
                >
                  <Download size={14} /> Descargar Resolución
                </a>
              </div>
            )}

            {/* Hilo de mensajes */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '1.5rem', maxHeight: '400px', overflowY: 'auto', paddingRight: '0.5rem' }}>
              {resultadoSeg.workflow_steps?.length > 0 ? (
                resultadoSeg.workflow_steps.map((step) => {
                  const isFuncionario = !!step.worker_id;
                  const isPago = step.payload?.tipo === 'comprobante_pago';

                  return (
                    <div key={step.id} style={{
                      alignSelf: isFuncionario ? 'flex-start' : 'flex-end',
                      maxWidth: '85%',
                      background: isFuncionario ? '#f3f4f6' : 'var(--primary)',
                      color: isFuncionario ? '#374151' : '#ffffff',
                      padding: '0.8rem 1rem',
                      borderRadius: '12px',
                      borderTopLeftRadius: isFuncionario ? '2px' : '12px',
                      borderTopRightRadius: isFuncionario ? '12px' : '2px',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px', gap: '1rem' }}>
                        <span style={{ fontSize: '0.72rem', fontWeight: 700, opacity: 0.8 }}>
                          {isFuncionario ? 'Funcionario' : 'Tú'}
                        </span>
                        <span style={{ fontSize: '0.65rem', opacity: 0.6 }}>
                          {new Date(step.created_at).toLocaleString('es-CL', { dateStyle: 'short', timeStyle: 'short' })}
                        </span>
                      </div>

                      {isPago && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: isFuncionario ? '#059669' : '#d1fae5', fontSize: '0.75rem', fontWeight: 700, marginBottom: 4 }}>
                          <DollarSign size={12} /> Comprobante de Pago Subido
                        </div>
                      )}

                      {step.payload?.asunto && (
                        <div style={{ fontWeight: 700, fontSize: '0.82rem', marginBottom: 2 }}>{step.payload.asunto}</div>
                      )}

                      <div style={{ fontSize: '0.85rem', whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>
                        {step.payload?.mensaje || step.payload?.comentario}
                      </div>
                    </div>
                  );
                })
              ) : (
                <p className="text-muted" style={{ textAlign: 'center', fontSize: '0.85rem', padding: '1rem' }}>
                  No hay mensajes todavía.
                </p>
              )}
            </div>

            {/* Responder */}
            <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '1.5rem' }}>
              <h4 style={{ fontSize: '0.9rem', marginBottom: '0.8rem', color: 'var(--primary-dark)' }}>Responder o enviar duda:</h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                <textarea
                  rows={3}
                  className="form-control"
                  placeholder="Escribe tu mensaje aquí..."
                  value={comentario}
                  onChange={e => setComentario(e.target.value)}
                  style={{ fontSize: '0.85rem', background: '#f8fafc' }}
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <button
                    onClick={onEnviarComentario}
                    className="btn btn-primary btn-sm"
                    disabled={enviandoComentario || !comentario.trim()}
                    style={{ borderRadius: '20px', padding: '0.5rem 1.2rem' }}
                  >
                    {enviandoComentario ? (
                      <span className="spinner" style={{ width: 14, height: 14 }} />
                    ) : (
                      <><Send size={14} style={{ marginRight: 6 }} /> Enviar Respuesta</>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {resultadoSeg.documentos?.length > 0 && (
            <div style={{ marginTop: '2rem', paddingTop: '1rem', borderTop: '1px solid var(--border-color)' }}>
              <h4 style={{ marginBottom: '1rem' }}>Documentos Adjuntos</h4>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {resultadoSeg.documentos.map(doc => (
                  <li key={doc.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.8rem', background: 'var(--bg-body)', borderRadius: '6px', marginBottom: '0.5rem' }}>
                    <div>
                      <FileIcon size={18} style={{ display: 'inline', marginRight: '8px', color: 'var(--copper)' }} />
                      {doc.nombre_original}
                      {doc.repertorio && (
                        <span style={{ marginLeft: '10px', fontSize: '0.75rem', padding: '2px 6px', background: 'var(--primary-light)', color: 'var(--primary-dark)', borderRadius: '4px', fontWeight: 600 }}>
                          Repertorio #{doc.repertorio.numero_repertorio}
                        </span>
                      )}
                    </div>
                    <button
                      className="icon-btn icon-btn-view"
                      onClick={() => onDownloadDoc(doc)}
                      style={{ padding: '6px 12px', gap: '6px', fontSize: '0.8rem', fontWeight: 600 }}
                    >
                      <Download size={16} strokeWidth={2.5} /> Descargar
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
